export default __webpack_public_path__ + "static/media/3-2-2.fb5039ff.jpg";